import { AlertTriangle } from "lucide-react";

export function ConfirmDialog({ open, title, description, confirmLabel = "Elimina", cancelLabel = "Annulla", danger = true, onConfirm, onClose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-stone-900/40 backdrop-blur-sm flex items-center justify-center p-4 z-[60]" onClick={onClose}>
      <div data-testid="confirm-dialog" className="bg-white rounded-sm w-full max-w-md shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="p-6 flex items-start gap-4">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${danger ? "bg-alert/10 text-alert" : "bg-brand/10 text-brand"}`}>
            <AlertTriangle size={20} />
          </div>
          <div>
            <h3 className="font-serif text-2xl text-stone-900 leading-tight">{title}</h3>
            {description && <p className="text-sm text-stone-500 mt-1.5">{description}</p>}
          </div>
        </div>
        <div className="px-6 pb-6 flex justify-end gap-3">
          <button data-testid="confirm-cancel-btn" onClick={onClose}
            className="px-5 py-2.5 text-sm text-stone-600 hover:bg-stone-100 rounded-sm transition-colors">{cancelLabel}</button>
          <button data-testid="confirm-ok-btn" onClick={onConfirm}
            className={`rounded-full px-6 py-2.5 text-sm font-semibold text-white transition-colors ${danger ? "bg-alert hover:bg-alert/90" : "bg-brand hover:bg-brand-hover"}`}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
